import { FormControl, Autocomplete, TextField } from "@mui/material";
import React from "react";

interface KeyValue {
    id: string;
    label: string;
}

interface AdvancedSearchMultiSelectWithStringsProps {
    dataList: KeyValue[];
    label: string;
    id: string;
    defaultValue: KeyValue[];
    handleSelectionChanged: (ids: string[]) => void;
}

const AdvancedSearchMultiSelectWithStringIds: React.FC<
    AdvancedSearchMultiSelectWithStringsProps
> = (props) => {
    const onTagsChange = (event: React.SyntheticEvent, value: Array<KeyValue>) => {
        var keys = value.map((x) => x.id.toString());
        props.handleSelectionChanged(keys);
    };

    const selectId = "select-" + props.id;

    return (
        <FormControl fullWidth>
            <Autocomplete
                size="small"
                multiple
                id={selectId}
                options={props.dataList}
                getOptionLabel={(option) => option.label}
                onChange={onTagsChange}
                defaultValue={props.defaultValue}
                renderInput={(params) => (
                    <TextField {...params} label={props.label} placeholder={props.label} />
                )}
            />
        </FormControl>
    );
};

export default AdvancedSearchMultiSelectWithStringIds;
